export default {
  execute(input) {
    // verify if input has content
    for(var prop in input) {
      if(prop!=='blankCards') {
        if((input[prop]===null || input[prop]==='') ||
           (input[prop].constructor === Array && input[prop].length===0)) {
          var res = {};
          res.err = true;
          res.msg = prop + ' values missing';
          return res;
        }
      }
    }
    // **************************************************************
    // ******************** variable declaration ********************
    // input data
    var cards = clone(input.cards);
    var criteria = [];
    var blank_cards = [];
    var ranking = 0;
    var ratio_z = input.ratioZ[0][Object.keys(input.ratioZ[0])[0]];
    var decimal_places = input.decimalPlaces[0][Object.keys(input.decimalPlaces[0])[0]];
    var weight_type = input.weightType[0][Object.keys(input.weightType[0])[0]];;

    // 0 = least important, ranking - 1 = most important
    var ranking_order = [];
    // ranking_order without blank cards and other values calculated
    var order_criteria = [];
    // sum of all e'r values
    var e = 0;
    var u = 0;
    // K - sum of all non-normalized weights
    var sum_k = 0;
    // K2 - sum of all ki'' (ki2)
    var sum_k2 = 0;
    var v = 0;
    var listL1 = [];
    var listL2 = [];
    var m = [];
    var fPlus = [];
    var fMinus = [];
    
    // **************************************************************
    // ******************** main algorithm flow *********************

    for(var element of cards) {
      if(element['Name'] !== 'Blank')
        criteria.push(element);
      else
        blank_cards.push(element);
      if(element['Position']>ranking) 
        ranking = element['Position'];
    }

    buildRanking();

    calculateER();

    calculateE();

    calculateU();

    calculateNonNormalizedWeight();

    transferNonNormalizedData();

    calculateSumK();

    calculateKI1();

    calculateK2();

    calculateSumK2();

    calculateV();

    calculateRatioDI1();

    calculateRatioDI2();

    buildListL1();

    buildListL2();

    buildListM();

    buildListsF();

    roundNormalizedWeights();

    return criteria;

    // **************************************************************
    // ******************** auxiliary functions *********************

    function clone(object) {
      return JSON.parse(JSON.stringify(object))
    }

    function buildRanking() {
      for(var i = 0; i < ranking; i++) {
        // new position of ranking order
        var new_pos = {};
        // cards in the current position
        var pos_cards = [];
  
        for(var criterion in criteria)
          if(criteria[criterion]['Position'] == ranking - i)
            pos_cards.push(criteria[criterion]['Name']);
  
        for(var blank_card in blank_cards)
          if(blank_cards[blank_card]['Position'] == ranking - i)
            pos_cards.push('blank_card');
  
        new_pos['Position'] = i;
        new_pos['cards'] = pos_cards;
        ranking_order.push(new_pos);
      }
    }
  
    function calculateER() {
      for(var rank in ranking_order) {
        // number of blank cards between rank r and r + 1
        var e_r = 0;
  
        // do not calculate e'r for the most important criteria
        if(!ranking_order[rank]['cards'].includes('blank_card')) {
          if(Number(rank) < ranking_order.length - 1) {
            // copy of the rank variable, so that it doesn't change
            var rank_aux = clone(Number(rank));
            // increment e_r if there are any blank cards in the between the ranks r and r+1
            while(ranking_order[Number(rank_aux) + 1]['cards'].includes('blank_card')) {
              e_r += ranking_order[Number(rank_aux) + 1]['cards'].length;
              rank_aux++;
            }
  
            // add the er value to the rank object
            ranking_order[rank]['er'] = e_r + 1;
          }
          else
            ranking_order[rank]['er'] = 0;
  
          // add the object to the order_criteria array
          order_criteria.push(ranking_order[rank]);
        }
      }
    }
  
    function calculateE() {
      for(var criterion in order_criteria) {
        e += order_criteria[criterion]['er'];
      }
    }
  
    function calculateU() {
      // 6 decimal places
      u = Math.round(((ratio_z - 1) / e) * 1000000) / 1000000;
    }
  
    function calculateNonNormalizedWeight() {
      for(var criterion in order_criteria) {
        // sum of e'r before rank r
        var sum_er = 0;
  
        for(var rank = 0; rank < Number(criterion); rank++)
          sum_er += order_criteria[rank]['er'];
        
        order_criteria[criterion]['Non-Normalized Weight'] = Math.round((1 + u * sum_er) * 100) / 100;
      }
    }
  
    // normalized weigths must be calculated by criterion, not by rank
    function transferNonNormalizedData() {
      for(var criterion in criteria)
        for(var rank in order_criteria)
          if(order_criteria[rank]['cards'].includes(criteria[criterion]['Name'])) {
            criteria[criterion]['ki'] = order_criteria[rank]['Non-Normalized Weight'];
            criteria[criterion]['Non-Normalized Weight'] = order_criteria[rank]['Non-Normalized Weight'];
          }
    }
  
    function calculateSumK() {
      for(var criterion in criteria)
        sum_k += criteria[criterion]['ki'];
    }
  
    // KI1 = ki*
    function calculateKI1() {
      for(var criterion in criteria)
        criteria[criterion]['ki1'] = (100 / sum_k) * criteria[criterion]['ki'];
    }
  
    // K2 = ki''
    function calculateK2() {
      for(var criterion in criteria)
        criteria[criterion]['ki2'] = Math.floor(criteria[criterion]['ki1'] * Math.pow(10, Number(decimal_places))) / Math.pow(10, Number(decimal_places));
    }
  
    function calculateSumK2() {
      for(var criterion in criteria)
        sum_k2 += criteria[criterion]['ki2'];
    }
  
    function calculateV() {
      var var_e = 100 - sum_k2;
  
      v = Math.round(Math.pow(10, decimal_places) * var_e);
    }
  
    function calculateRatioDI1() {
      for(var criterion in criteria)
        criteria[criterion]['di1'] = (Math.pow(10, -Number(decimal_places)) - (criteria[criterion]['ki1'] - criteria[criterion]['ki2'])) / criteria[criterion]['ki1'];
    }
  
    function calculateRatioDI2() {
      for(var criterion in criteria)
        criteria[criterion]['di2'] = (criteria[criterion]['ki1'] - criteria[criterion]['ki2']) / criteria[criterion]['ki1'];
    }
  
    function compareDI1(a, b) {
      if(a['di1'] < b['di1'])
        return -1;
      else if(a['di1'] > b['di1'])
        return 1;
      else {
        if(a['index'] < b['index'])
          return 1;
        else if(a['index'] > b['index'])
          return -1;
        else
          return 0;
      }
    }
  
    function buildListL1() {
      for(var criterion in criteria) {
        var new_pair = {};
  
        new_pair['index'] = Number(criterion) + 1;
        new_pair['di1'] = criteria[criterion]['di1'];
  
        listL1.push(new_pair);
      }
  
      listL1.sort(compareDI1);
    }
  
    function compareDI2(a, b) {
      if(a['di2'] < b['di2'])
        return 1;
      else if(a['di2'] > b['di2'])
        return -1;
      else {
        if(a['index'] < b['index'])
          return 1;
        else if(a['index'] > b['index'])
          return -1;
        else
          return 0;
      }
    }
  
    function buildListL2() {
      for(var criterion in criteria) {
        var new_pair = {};
  
        new_pair['index'] = Number(criterion) + 1;
        new_pair['di2'] = criteria[criterion]['di2'];
  
        listL2.push(new_pair);
      }
  
      listL2.sort(compareDI2);
    }
  
    function buildListM() {
      for(var criterion in criteria) {
        var index = Number(criterion) + 1;
  
        if(criteria[criterion]['di1'] > criteria[criterion]['di2'])
          m.push(index);
      }
    }
  
    function buildListsF() {
      if(m.length + v <= criteria.length) {
        // list F-
        // the m criteria of M
        for(var criterion in m)
          fMinus.push(m[criterion]);
  
        // the n-v-m last criteria of listL2 not belonging to M
        var crt_count = criteria.length - v - m.length;
  
        for(var i = listL2.length - 1; i >= 0; i--) {
          if(!m.includes(listL2[i]['index']) && crt_count > 0) {
            fMinus.push(listL2[i]['index']);
            crt_count--;
          }
        }
  
        // list F+
        // the first v criteria of L not belonging to M
        crt_count = v;
  
        for(var criterion in listL2) {
          if(!m.includes(listL2[criterion]['index']) && crt_count > 0) {
            fPlus.push(listL2[criterion]['index']);
            crt_count--;
          }
        }
      }
      else if(m.length + v > criteria.length) {
        // list F-
        // last n-v criteria of L not belonging to M
        var crt_count = criteria.length - v;
  
        for(var i = listL1.length - 1; i >= 0; i--) {
          if(m.includes(listL1[i]['index']) && crt_count > 0) {
  
            fMinus.push(listL1[i]['index']);
            crt_count--;
          }
        }
  
        // add the remaining criteria - ENGLISH PAPER IS NOT EXPLICIT AND CONTRADICTORY WITH THE FRENCH VERSION
        for(var criterion in criteria)
          if(!fMinus.includes(Number(criterion) + 1))
            fPlus.push(Number(criterion) + 1);
  
        //POSSIBLE SOLUTION FOR CONTRADICTORY PAPERS
        //list F+
        //n-m criteria of L1 not belonging to M
        /*for(i = 0; i < criteria.length - m.length; i++)
          if(!m.includes(listL1[i]['index']))
            fPlus.push(listL1[i]['index']);
  
        //v + m - n first criteria of L1 belonging to M
        for(i = 0; i < v + m.length - criteria.length; i++)
          if(m.includes(listL1[i]['index']))
            fPlus.push(listL1[i]['index']);*/
      }
    }
  
    function roundNormalizedWeights() {
      for(var criterion in criteria) {
        if(fPlus.includes(Number(criterion) + 1))
          criteria[criterion]['Normalized Weight'] = Number((criteria[criterion]['ki2'] + Math.pow(10, -decimal_places)).toFixed(decimal_places));
        else
          criteria[criterion]['Normalized Weight'] = Number(criteria[criterion]['ki2'].toFixed(decimal_places));
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/services/DCMSRFService.js